<template>
  <div class="show-actions-container text-right">
    <slot></slot>
    <button class="ph-btn show-action-btn download ml-2" @click="$emit('clickOnDownloadBtn')" v-if="downloadItem">
      {{$t('Download')}} <i class="ph-custom ph-file-arrow-down ml-1"/>
    </button>
    <button class="btn-secondary ph-btn show-action-btn ml-2" v-if="auditButtonShown && farmerHasACurrentAudit" @click="$emit('clickOnConsultAuditBtn')">
       {{$t('Consult') + ' ' + $t('l.i') + $t('audit') + ' ' + $t('ongoing')}} <i class="ph-custom ml-1 ph-folder-notch-fill"/>
    </button>
    <button class="btn-secondary ph-btn show-action-btn ml-2" v-else-if="auditButtonShown && farmerHasAInProgressAudit" @click="$emit('clickOnCreateAuditBtn')" :disabled="!canCreateAudit" :title="canCreateAudit ? '' : $t('Only.technician.validate')">
      {{$t('Validate') + ' ' + $t('l.i') + $t('audit') }} <i class="ph-custom ml-1 ph-folder-notch-plus-fill"/>
    </button>
    <button class="btn-secondary ph-btn show-action-btn ml-2" v-else-if="auditButtonShown && !farmerHasAInProgressAudit" @click="$emit('clickOnCreateAuditBtn')" :disabled="!canCreateAudit" :title="canCreateAudit ? '' : $t('Only.technician.create')">
        {{$t('Add') + ' ' + $t('a') + ' ' + $t('audit') }} <i class="ph-custom ml-1 ph-folder-notch-plus-fill"/>
    </button>
    <button class="show-action-btn resetPassword ml-2" @click="$emit('clickOnResetPasswordBtn')" v-if="resetPassword">
      <img class="btn-icon" :src="require(`@/assets/images/reset-password.svg`)" alt="reset password icon" height="18">
    </button>
    <button class="ph-btn show-action-btn edit ml-2" @click="$emit('clickOnEditBtn')" v-if="editItem">
      {{$t('Modify')}} <i class="ph-custom ph-pencil-simple-line-fill ml-1"/>
    </button>
    <button class="ph-btn show-action-btn delete ml-2" @click="$emit('clickOnDeleteBtn')" v-if="deleteItem">
      {{$t('Delete')}}<i class="ph-custom ph-trash-fill ml-1"/>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ShowActions',

  props: {
    auditButtonShown: {
      type: Boolean,
      default: false
    },
    farmerHasACurrentAudit: {
      type: Boolean,
      default: false
    },
    farmerHasAInProgressAudit: {
      type: Boolean,
      default: false
    },
    canCreateAudit: {
      type: Boolean,
      default: false
    },
    resetPassword: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Boolean,
      default: true
    },
    deleteItem: {
      type: Boolean,
      default: true
    },
    downloadItem: {
      type: Boolean,
      default: false
    },
    isFarmer: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

.show-actions-container {
  min-width: 300px;
  display: flex;
  justify-content: flex-end;
}
.show-action-btn {
  border: none;
  border-radius: 10px;
  height: 40px;
  min-width: 175px;
  font-family: "Museo700", "Arial", sans-serif;
  font-size: 14px;
}
.show-action-btn:hover {
  background-color: var(--main-color-medium);
}

.edit {
  background-color: var(--main-green-light);
  color: var(--main-color-dark);

}
.edit:hover {
  background-color: var(--main-color-medium);
}

.delete{
  background-color: var(--main-red-light);
  color: var(--main-red-dark);
}
.delete:hover {
  background-color: var(--main-red-medium);
}

.resetPassword {
  background-color: var(--main-black);
}
.resetPassword:hover {
  background-color: var(--main-grey);
}

.audit {
  background-color: var(--main-yellow-light);
  color: var(--main-yellow-dark);

}
.audit:hover {
  background-color: var(--main-yellow-medium);
}

.download {
  background-color: var(--main-yellow-light);
  border-color: var(--main-yellow-light);
  color: var(--main-yellow-dark);
}

.download:hover {
  background-color: var(--main-yellow-medium);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/ShowActions.vue